module.exports = __webpack_public_path__ + "img/background-intro-lg.acf4e21b.svg";